import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <main className="main-content page-enter">
    <div className="not-found">
      <h2 className="graffiti-tag not-found-code">404</h2>
      <p className="not-found-text">Diese Seite existiert nicht.</p>
      <Link to="/" className="urban-button">← Zur Startseite</Link>
    </div>
  </main>
);

export default NotFound;
